// extracted by mini-css-extract-plugin
export var actionRow = "_ne-6";
export var card = "_ne-0";
export var chevron = "_ne-5";
export var content = "_ne-2";
export var details = "_ne-3";
export var eventActionToggle = "_ne-4";
export var icon = "_ne-1";
export var iconBlue = "_ne-8";
export var iconBrand = "_ne-7";
export var iconGrayBlue = "_ne-9";
export var iconGreen = "_ne-a";
export var iconIndigo = "_ne-b";
export var iconOrange = "_ne-c";
export var iconPurple = "_ne-d";
export var iconRed = "_ne-e";
export var iconWarning = "_ne-f";